import { USER_RIGHTS_CONSTANTS } from './constants'
import {AuthConstants} from "../auth/constants";

export function userRights(state = {}, action) {
  switch (action.type) {
    case USER_RIGHTS_CONSTANTS.GET_USER_RIGHTS_REQUEST:
      return {
        ...state,
        rights: null,
      }
    case USER_RIGHTS_CONSTANTS.GET_USER_RIGHTS_SUCCESS:
      return {
        ...state,
        rights: action.response.results,
      }

    case USER_RIGHTS_CONSTANTS.GET_USER_RIGHTS_FAILURE:
      return {
        ...state,
        rights: null,
      }
    case AuthConstants.DELETE_AUTH_INFO: {
      return {}
    }

    default:
      return state
  }
}
